import { memo, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

/** 骨架行近似高度：padding 8+8 + cell 12 + border 1 */
const ORDERS_SKELETON_ROW_HEIGHT = 29;
const ORDERS_SKELETON_ROW_MIN = 8;

/** 图表区骨架：图例条 + 绘图区铺满，所有图种共用 */
export function ChartExplorerChartSkeleton() {
	return (
		<div className='chart-xpl-chart-skeleton' aria-hidden='true'>
			<div className='chart-xpl-browse__shimmer chart-xpl-chart-skeleton__legend-item' />
			<div className='chart-xpl-browse__shimmer chart-xpl-chart-skeleton__fill' />
		</div>
	);
}

export function ChartExplorerOrdersSkeleton({ className }) {
	const scrollRef = useRef(null);
	const [rowCount, setRowCount] = useState(ORDERS_SKELETON_ROW_MIN);

	useEffect(() => {
		const el = scrollRef.current;
		if (!el) return undefined;

		const updateRowCount = () => {
			const height = el.clientHeight;
			if (height <= 0) return;
			setRowCount(Math.max(ORDERS_SKELETON_ROW_MIN, Math.ceil(height / ORDERS_SKELETON_ROW_HEIGHT) + 1));
		};

		updateRowCount();
		if (typeof ResizeObserver === 'undefined') return undefined;

		const observer = new ResizeObserver(updateRowCount);
		observer.observe(el);
		return () => observer.disconnect();
	}, []);

	return (
		<div className={classNames('chart-xpl-otable-wrap', className)} role='status' aria-label='加载订单'>
			<p className='chart-xpl-detail-loading__status chart-xpl-detail-loading__status--orders'>加载中…</p>
			<div ref={scrollRef} className='chart-xpl-otable-scroll chart-xpl-otable-scroll--skeleton' aria-hidden='true'>
				{Array.from({ length: rowCount }).map((_, index) => (
					<div key={index} className='chart-xpl-otable__skeleton-row'>
						<div className='chart-xpl-browse__shimmer chart-xpl-otable__skeleton-cell' />
						<div className='chart-xpl-browse__shimmer chart-xpl-otable__skeleton-cell chart-xpl-otable__skeleton-cell--wide' />
						<div className='chart-xpl-browse__shimmer chart-xpl-otable__skeleton-cell chart-xpl-otable__skeleton-cell--narrow' />
						<div className='chart-xpl-browse__shimmer chart-xpl-otable__skeleton-cell' />
					</div>
				))}
			</div>
		</div>
	);
}

/** L1 · 图表 + 订单区加载骨架 */
function ChartExplorerDetailLoading({ showOrdersPane = true }) {
	return (
		<div
			className={classNames('chart-xpl-split chart-xpl-detail-loading', !showOrdersPane && 'is-chart-only')}
			aria-busy='true'
			aria-label='加载图表'
			role='status'
		>
			<div className='chart-xpl-detail-loading__chart'>
				<p className='chart-xpl-detail-loading__status'>加载中…</p>
				<ChartExplorerChartSkeleton />
			</div>

			{showOrdersPane ? (
				<>
					<div className='chart-xpl-split__handle chart-xpl-detail-loading__handle' aria-hidden='true' />
					<div className='chart-xpl-detail-loading__orders'>
						<div className='chart-xpl-detail-loading__orders-head'>
							<div className='chart-xpl-browse__shimmer chart-xpl-detail-loading__head-line' />
							<div className='chart-xpl-browse__shimmer chart-xpl-detail-loading__head-count' />
						</div>
						<div className='chart-xpl-orders__table'>
							<ChartExplorerOrdersSkeleton />
						</div>
					</div>
				</>
			) : null}
		</div>
	);
}

export default memo(ChartExplorerDetailLoading);
